/**
 * "See an example" on the upload screen (Oct 2026 revamp).
 *
 * Granted shows a sample bill so people know which piece of paper to
 * upload, and it's a good idea: a lot of what lands in our inbox is a
 * summary statement or an EOB. The hospital, patient and numbers below
 * are made up.
 */

import Modal from './Modal';

const ROWS = [
  { date: 'Sep 3', what: 'Emergency room visit, level 4', code: '99284', amt: '1,850.00' },
  { date: 'Sep 3', what: 'Complete blood count', code: '85025', amt: '186.00' },
  { date: 'Sep 3', what: 'Metabolic panel', code: '80053', amt: '242.00' },
  { date: 'Sep 3', what: 'CT scan, head, no contrast', code: '70450', amt: '2,410.00' },
  { date: 'Sep 3', what: 'IV push, single drug', code: '96374', amt: '398.00' },
];

export default function ExampleBillModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} onClose={onClose} className="exb" showClose closeLabel="Close example">
      <h2 className="exb-title">What a bill looks like</h2>
      <p className="exb-sub">
        The best one to send is an itemized bill: every charge on its own line,
        with a date, a code and an amount. If yours only shows a total, upload
        it anyway and we'll ask for the itemized one.
      </p>

      <div className="exb-paper" aria-label="Example itemized bill">
        <span className="exb-tag">Example</span>
        <div className="exb-head">
          <div>
            <p className="exb-org">Riverside General Hospital</p>
            <p className="exb-meta">Patient: Jane Doe · Account 0048213</p>
          </div>
          <p className="exb-meta exb-right">Statement date<br />Oct 1, 2026</p>
        </div>
        <table className="exb-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Code</th>
              <th className="exb-num">Amount</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r) => (
              <tr key={r.code}>
                <td>{r.date}</td>
                <td>{r.what}</td>
                <td>{r.code}</td>
                <td className="exb-num">${r.amt}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="exb-total">
          <span>Amount due</span>
          <span className="exb-num">$5,086.00</span>
        </div>
      </div>
    </Modal>
  );
}
